import { ApiHosts, handleResponseOld, makeGet } from './helpers';

/**
 * GET search/similaritemsgroups
 * @category Search API
 * @see https://github.com/LIVEauctioneers/search-party internal handlers for SimilarItemsGroups
 */
export type FetchSimilarItemsGroupsParams = {
    authToken: string;
    deployment: string;
    ipAddress: string;
    isBot: boolean;
    itemId: number;
    useChairishSimilarItems?: boolean;
};

export const fetchSimilarItemsGroups = ({
    authToken,
    deployment,
    ipAddress,
    isBot,
    itemId,
    useChairishSimilarItems,
}: FetchSimilarItemsGroupsParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'similaritemsgroups',
            authToken,
            deployment,
            ipAddress,
            path: ApiHosts.Search,
        });
        const query = {
            isBot,
            itemId,
            useChairishSimilarItems: useChairishSimilarItems ? 'true' : 'false',
        };
        request.query(query);
        request.end((err, response) => {
            handleResponseOld({ err, reject, resolve, response });
        });
    });

export default { fetchSimilarItemsGroups };
